import { Container, Grid, Box, Link } from '@mui/material';
import React from 'react';
import ContactScss from './Contact.module.scss';
import OurCover from '../../Component/OurCover/OurCover';
import GoMap from '../../Component/GoogleMaps/GoogleMap'

function Contact() {
    return (
        <div>
            <OurCover ourHead="Contact Us" title="We helps startups and digital agencies launch projects on time" />
            {/* contactInfo */}
            <section id={ContactScss.contactInfo}>
                <Container maxWidth='lg'>
                    <Grid container sx={{ mx: '-15px', width: 'auto' }}>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={ContactScss.contactInfoItem}>

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z" /></svg>
                                <Box className={ContactScss.contactInfoItemRight}>
                                    <h5>Address</h5>
                                    <address>
                                        476 Franecki Underpass Apt.<br />
                                        486 United Kingdom
                                    </address>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={ContactScss.contactInfoItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M320 0H64C37.49 0 16 21.49 16 48v416C16 490.5 37.49 512 64 512h256c26.51 0 48-21.49 48-48v-416C368 21.49 346.5 0 320 0zM192 464c-17.75 0-32-14.25-32-32s14.25-32 32-32s32 14.25 32 32S209.8 464 192 464z" /></svg>
                                <Box className={ContactScss.contactInfoItemRight}>
                                    <h5>Information</h5>
                                    <Box className={ContactScss.contactInfoItemRightBox}>
                                        <Link href="tel:+1800123123">Hotline:1-800-123-123</Link>
                                        <Link href="mailto:xamiyev_enver@mail.ru">Mail:xamiyev_enver@mail.ru</Link>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={ContactScss.contactInfoItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z" /></svg>
                                <Box className={ContactScss.contactInfoItemRight}>
                                    <h5>Open hour</h5>
                                    <Box className={ContactScss.contactInfoItemRightBox}>
                                        Monday - Friday: 09:00 - 20:00<br />
                                        Sunday & Saturday: 10:30 - 22:00
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            {/* google map */}
            <section id={ContactScss.contactMapBox}>
                <Container maxWidth='lg'>
                    <Box className={ContactScss.contactMapHead}>
                        find google map
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z" /></svg>
                    </Box>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box className={ContactScss.contactMap}>
                                <GoMap />
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            {/* form */}
            <section id={ContactScss.formBox}>
                <Container maxWidth='lg'>
                    <Box className={ContactScss.formHead}>
                        <span> get in touch</span>
                        <h2>Let's talk together</h2>
                    </Box>
                    <form className={ContactScss.formBody}>
                        <Grid container sx={{ width: 'auto', mx: '-15px' }}>
                            <Grid item xs={12} sm={6} md={6} sx={{ px: '15px' }}>
                                <Box className={ContactScss.formItem}>
                                    <input type='text' placeholder='Name'></input>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} sx={{ px: '15px' }}>
                                <Box className={ContactScss.formItem}>
                                    <input type='email' placeholder='Email'></input>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} sx={{ px: '15px' }}>
                                <Box className={ContactScss.formItem}>
                                    <input type='text' placeholder='Subject'></input>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} sx={{ px: '15px' }}>
                                <Box className={ContactScss.formItem}>
                                    <textarea rows="6" placeholder="Message"></textarea>
                                </Box>
                            </Grid>
                            <Box className={ContactScss.formSub}>
                                <button type='submit'>
                                    send message
                                </button>
                            </Box>
                        </Grid>
                    </form>
                </Container>
            </section>
        </div >
    )
}

export default Contact;